import { IcmPeriodPicker } from "@/icm/common";
import type { IcmPeriod } from "@/icm/types";

interface PayBreakdownPeriodNavProps {
  periods: IcmPeriod[];
  calendarPeriods: IcmPeriod[];
  selectedPeriodStart: string | undefined;
  onSelect: (periodStart: string) => void;
  isLoading?: boolean;
}

export const PayBreakdownPeriodNav = ({
  periods,
  calendarPeriods,
  selectedPeriodStart,
  onSelect,
  isLoading,
}: PayBreakdownPeriodNavProps) => (
  <IcmPeriodPicker
    variant="button"
    periods={periods}
    calendarPeriods={calendarPeriods}
    selectedPeriodStart={selectedPeriodStart}
    onSelect={onSelect}
    isLoading={isLoading}
    className="shrink-0 text-subtle max-sm:-ml-2.5"
  />
);
